export const news = {
    newsFeedCreateInputPlaceholder: 'Write a post...',
    newsFeedSearchInputPlaceholder: 'Search',
    newsFeedPostOwnerCurtainEditTitle: 'Edit post',
    newsFeedPostOwnerCurtainDeleteTitle: 'Delete post',
    newsFeedEditedPostSavedAlertText: 'Post saved!',
    newsFeedEditedPostDeletedAlertText: 'Post deleted!',
    newsFeedShareCurtainOptionTitle: 'Copy link',
    newsFeedPostLinkCopiedAlertText: 'Link copied!',
    newsFeedOthersPostCurtainOptionCopyTitle: 'Copy link',
    newsFeedOthersPosLinkCopiedAlertText: 'Link copied!',
    newsFeedOthersPostCurtainOptionFlagTitle: 'Flag content',
    newsFeedOtherPostOwnersCurtainDeleteTitle: 'Delete post',
    newsFeedPostDeletePopupTitle: 'Delete',
    newsFeedPostDeletePopupText: 'Delete this post?',
    newsFeedPostDeletePopupCancelButtonTitle: 'Cancel',
    newsFeedPostDeletePopupConfirmButtonTitle: 'Confirm',
    newsFeedPostDeeletedAlertText: 'Post deleted!',
    newsPostDetailsHeaderTitle: 'Post',
    postFeedPostLikesText: 'Likes',
    postFeedPostCommentsText: 'Comments',
    postFeedPostNoLikesText: 'There are no likes yet',
    postFeedPostLeaveFirstLikeText: 'You can leave the first one',
    newsFeedPostDetailsNoCommentsText: 'There are no comments yet',
    newsFeedPostDetailsFirstCommentText: 'You can leave the first one',
    newsFeedPostDetailsShareOptionTitle: 'Copy link',
    newsFeedPostDetailsSharePostCopiedAlertText: 'Link copied!',
    newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copy link',
    newsFeedPostDetailsCopiedAlertText: 'Link copied!',
    newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Flag content',
    newsPostDetailsFlagCurtainOptionSpamTitle: 'Flag',
    newsPostDetailsReportedCurtainText: 'Content reported',
    newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Edit comment',
    newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Delete comment',
    newsPostDetailsEditedCommentSavedAlertText: 'Comment saved!',
    postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Delete comment',
    postDetailsOtherUsersCommentDeletadAlertText: 'Comment deleted!',
    postDetailsDeleteCommentPopupTitle: 'Delete',
    postDetailsDeleteCommentPopupText: 'Delete this comment?',
    postDetailsDeleteCommentPopupCancelButtonTitle: 'Cancel',
    postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirm',
    postDetailsCommDeletedAlertText: 'Comment deleted!',
    postDetailsCommentUserCurtainOptionTitle: 'Flag comment',
    newsCreatePostCurtainTitle: 'New post',
    newsCreatePostCurtainBodyPlaceholder: 'Place your text here...',
    newsCreatePostPublishButtonTitle: 'Publish',
    newsCreatePostUploadSlallerImageAlertText: 'You can upload no more than {size} MB at once',
    newsPostSavedAlertText: 'Post saved!',
    newsCreatePostAddLocationCurtainTitle: 'Location',
    newsCreatePostAddLocationCurtainInputPlaceholder: 'Location name',
    newsCreatePostEditLocationCurtainText: 'Edit location',
    newsDeleteLocation: 'Delete location',
    newsDiscardPostPopupTitle: 'Draft',
    newsDiscardPostPopupText: 'Discard this Draft?',
    newsDiscardPostPopupCancelButtonTitle: 'Cancel',
    newsDiscardPostPopupCofirmButtonTitle: 'Confirm',
    newsNewPostCreatePollTitle: 'Create poll',
    newsNewPostCreatePollTitleInputPlaceholder: 'Title',
    newsNewPostCreatePollOptionInputPlaceholder: 'Option',
    newsNewPostCreatePollAddButtonTitle: 'Add option',
    newsNewPostCreatePollCreateButtonTitle: 'Create',
    newsCreatePostPollTitleBlankAlertText: 'Title can’t be blank!',
    newsCreatePostPollOptionBlankAlertText: 'Option can’t be blank!',
    newsCreatePostPollLongTitleAlertText: 'Title should contain at most {length} characters',
    newsCreatePostPollLongOptionAlertText: 'Option should contain at most {length} characters',
    newsCreatePostPollEditOptionTitle: 'Edit poll',
    newsCreatePostPollRemoveOptionTitle: 'Remove poll',
    newsPostPollInfoVotesText: 'votes',
    newsPostPollInfoEditVoteText: 'Edit vote',
    newsPostPollFinishPollText: 'Finish the poll',
    newsPostPollFinishedPollText: 'Finished',
    newsPostPollInProgresslText: 'In Progress',
    newsFinishPollCurtainTitle: 'Finish the poll',
    newsFinishPollCurtainText: 'Users won’t be able to vote after the poll is finished.',
    newsFinishPollCurtainCancelButtonTitle: 'Cancel',
    newsFinishPollCurtainConfirmlButtonTitle: 'Confirm',
    newsPollInfoPollVotesCurtainTitle: 'Poll Votes',
    newsEditPostCurtainTitle: 'Edit post',
    newsEditPostCurtainNoTextBodyPlaceholder: 'Place your text here...',
    newsEditPostCurtainSaveButtonTitle: 'Save',
    newsEditPostSavedAlertText: 'Post saved!',
    newsError: 'Something went wrong!',
    newsAt: 'at',
    newsSeeMore: 'See more...',
    newsMaxAttachments: 'You have exceeded max number of attachments. Max attachments is {length}',
    newsReply: 'Reply',
    newsPin: 'Pin post',
    newsUnpin: 'Unpin post'
}